import React, { Component } from 'react'

import { Image } from 'react-bootstrap';

export default class HeroImage extends Component {
    render() {
        return (
            <div className="hero">
                <Image alt="ISSC Team Photo" src={this.props.backgroundImage} className="hero-image" />
            </div>
        )
    }
}
